import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState, MessageState } from "@/types/RootState";

const AppMessage: React.FC = () => {
  const message: MessageState = useSelector(
    (state: RootState) => state.message
  );

  const [bgColor, setBgColor] = useState<string>("");

  useEffect(() => {
    switch (message.type) {
      case "INFO": {
        setBgColor("#1f8dad");
        break;
      }
      case "WARNING": {
        setBgColor("#f4b162");
        break;
      }
      case "ERROR": {
        setBgColor("#ec6666");
        break;
      }
      default: {
        break;
      }
    }
  }, [message]);

  return message.message ? (
    <div id="onUserPageMessage">
      <Alert
        variant={"grey"}
        className="text-center mb-0"
        style={{ color: "white", backgroundColor: bgColor }}
      >
        {message.message}
      </Alert>
    </div>
  ) : null;
};

export default AppMessage;
